var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifGeofenceEntered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 21,
    rx: 5.5,
    fill: "#F0A311",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 21,
    rx: 5.5,
    stroke: "#F0A311"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13212_72839)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13212_72839)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_13212_72839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4109 9.2526L15.0818 7.58594H16.9193V8.41927H15.4234L14.5901 9.2526H17.9609C19.0026 9.2526 19.8359 10.0859 19.8359 11.1276C19.8359 12.1693 19.0026 13.0026 17.9609 13.0026C17.0359 13.0026 16.2693 12.3276 16.1193 11.4484L15.2359 10.9193C15.2526 10.9901 15.2526 11.0568 15.2526 11.1276C15.2526 12.1693 14.4193 13.0026 13.3776 13.0026C12.3359 13.0026 11.5026 12.1693 11.5026 11.1276C11.5026 10.0859 12.3359 9.2526 13.3776 9.2526M16.9859 11.4443C17.1276 11.8651 17.5109 12.1693 17.9734 12.1693C18.2497 12.1693 18.5147 12.0595 18.71 11.8642C18.9054 11.6688 19.0151 11.4039 19.0151 11.1276C19.0151 10.8513 18.9054 10.5864 18.71 10.391C18.5147 10.1957 18.2497 10.0859 17.9734 10.0859C17.5068 10.0859 17.1276 10.3943 16.9859 10.8151H18.1693V11.4401L16.9859 11.4443ZM13.3901 12.1693C13.6664 12.1693 13.9313 12.0595 14.1267 11.8642C14.322 11.6688 14.4318 11.4039 14.4318 11.1276C14.4318 10.8513 14.322 10.5864 14.1267 10.391C13.9313 10.1957 13.6664 10.0859 13.3901 10.0859C13.1138 10.0859 12.8489 10.1957 12.6535 10.391C12.4582 10.5864 12.3484 10.8513 12.3484 11.1276C12.3484 11.4039 12.4582 11.6688 12.6535 11.8642C12.8489 12.0595 13.1138 12.1693 13.3901 12.1693Z",
    fill: "#F0A311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4766 14.3415H13.6591M13.6591 14.3415L14.5162 13.4844M13.6591 14.3415L14.5162 15.1987",
    stroke: "#F0A311",
    strokeWidth: 0.428571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_13212_72839",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8145 15.9026C15.9949 16.1194 15.9664 16.4431 15.737 16.6072C14.7781 17.2932 13.6589 17.7276 12.4825 17.8661C11.1366 18.0245 9.77362 17.7889 8.55905 17.1877C7.34448 16.5866 6.33051 15.6458 5.64022 14.4796C4.94993 13.3134 4.613 11.9719 4.67033 10.618C4.72765 9.26398 5.17677 7.95576 5.96316 6.85207C6.74956 5.74839 7.83942 4.8967 9.10045 4.40039C10.3615 3.90408 11.7395 3.78449 13.0672 4.05612C14.2277 4.29356 15.3061 4.82098 16.2036 5.58561C16.4183 5.7685 16.4194 6.09341 16.2213 6.29418C16.0233 6.49495 15.7012 6.49525 15.4843 6.31504C14.7293 5.68786 13.8292 5.25446 12.8625 5.05667C11.7285 4.82466 10.5515 4.92681 9.47447 5.35071C8.39741 5.77461 7.46656 6.50204 6.7949 7.4447C6.12324 8.38736 5.73965 9.50472 5.69068 10.6612C5.64172 11.8176 5.9295 12.9634 6.51907 13.9594C7.10865 14.9555 7.97469 15.759 9.01206 16.2724C10.0494 16.7859 11.2135 16.9871 12.3631 16.8518C13.3431 16.7364 14.2766 16.3807 15.0819 15.8195C15.3133 15.6583 15.6341 15.6858 15.8145 15.9026Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.8145 15.9026C15.9949 16.1194 15.9664 16.4431 15.737 16.6072C14.7781 17.2932 13.6589 17.7276 12.4825 17.8661C11.1366 18.0245 9.77362 17.7889 8.55905 17.1877C7.34448 16.5866 6.33051 15.6458 5.64022 14.4796C4.94993 13.3134 4.613 11.9719 4.67033 10.618C4.72765 9.26398 5.17677 7.95576 5.96316 6.85207C6.74956 5.74839 7.83942 4.8967 9.10045 4.40039C10.3615 3.90408 11.7395 3.78449 13.0672 4.05612C14.2277 4.29356 15.3061 4.82098 16.2036 5.58561C16.4183 5.7685 16.4194 6.09341 16.2213 6.29418C16.0233 6.49495 15.7012 6.49525 15.4843 6.31504C14.7293 5.68786 13.8292 5.25446 12.8625 5.05667C11.7285 4.82466 10.5515 4.92681 9.47447 5.35071C8.39741 5.77461 7.46656 6.50204 6.7949 7.4447C6.12324 8.38736 5.73965 9.50472 5.69068 10.6612C5.64172 11.8176 5.9295 12.9634 6.51907 13.9594C7.10865 14.9555 7.97469 15.759 9.01206 16.2724C10.0494 16.7859 11.2135 16.9871 12.3631 16.8518C13.3431 16.7364 14.2766 16.3807 15.0819 15.8195C15.3133 15.6583 15.6341 15.6858 15.8145 15.9026Z",
    stroke: "#F0A311",
    strokeWidth: 2,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-1_13212_72839)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13212_72839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13212_72839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.66406 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_13212_72839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 1 20.6641 5.91406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifGeofenceEntered);
export default __webpack_public_path__ + "static/media/notif-geofence-entered.eb3834a372549d34a931c2af837c96af.svg";
export { ForwardRef as ReactComponent };